/** Copyright (c) 2019 T.Rowe Price. All rights reserved. */

export const START_TOUR = 'START_TOUR';
export const STOP_TOUR = 'STOP_TOUR';

export const startTour = () => ({
  type: START_TOUR
});

export const stopTour = () => ({
  type: STOP_TOUR
});
